var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDiscountCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22787 16.637C3.68287 15.091 2.90987 14.319 2.62287 13.316C2.33487 12.313 2.58087 11.248 3.07287 9.119L3.35587 7.891C3.76887 6.099 3.97587 5.203 4.58887 4.589C5.20287 3.976 6.09887 3.769 7.89087 3.356L9.11887 3.072C11.2489 2.581 12.3129 2.335 13.3159 2.622C14.3189 2.91 15.0909 3.683 16.6359 5.228L18.4659 7.058C21.1569 9.748 22.4999 11.092 22.4999 12.762C22.4999 14.433 21.1549 15.777 18.4659 18.466C15.7769 21.157 14.4329 22.5 12.7619 22.5C11.0919 22.5 9.74687 21.155 7.05787 18.466L5.22787 16.637Z",
    stroke: "#026F30",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.521 10.7932C11.302 10.0122 11.302 8.74584 10.521 7.96479C9.73991 7.18374 8.47358 7.18374 7.69253 7.96479C6.91149 8.74584 6.91148 10.0122 7.69253 10.7932C8.47358 11.5743 9.73991 11.5743 10.521 10.7932Z",
    stroke: "#026F30",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.042 19L19.021 12.02",
    stroke: "#026F30",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscountCheckout);
export default __webpack_public_path__ + "static/media/icon-discount-checkout.ba5d16e24a5b9fbfc94addbcfa65bbcd.svg";
export { ForwardRef as ReactComponent };